var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6822,
    cy: 15.0001,
    r: 11.7447,
    stroke: "black",
    strokeWidth: 1.46809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2377 11.4818C19.5244 11.1952 19.5244 10.7304 19.2377 10.4438C18.9511 10.1571 18.4863 10.1571 18.1996 10.4438L14.6814 13.9619L11.1632 10.4438C10.8766 10.1571 10.4118 10.1571 10.1252 10.4438C9.83849 10.7304 9.83849 11.1952 10.1252 11.4818L13.6433 15L10.1252 18.5182C9.83849 18.8049 9.83849 19.2697 10.1252 19.5563C10.4118 19.843 10.8766 19.843 11.1632 19.5563L14.6814 16.0381L18.1996 19.5563C18.4863 19.843 18.9511 19.843 19.2377 19.5563C19.5244 19.2697 19.5244 18.8049 19.2377 18.5182L15.7195 15L19.2377 11.4818Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.0c7428cac6aaa8bd2eaa1a1322306b03.svg";
export { ForwardRef as ReactComponent };